import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      padding: 32,
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      gap: 24,
      alignItems: 'center',
      marginBottom: 20,

      '&:hover': {
        cursor: 'pointer',
      },
    },
    title: {
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: 700,
    },
  },
  {
    name: 'EditorSidebar',
  },
);

export default useStyles;
